import { render, staticRenderFns } from "./c_bg_color.vue?vue&type=template&id=e88bb144&scoped=true"
import script from "./c_bg_color.vue?vue&type=script&lang=js"
export * from "./c_bg_color.vue?vue&type=script&lang=js"
import style0 from "./c_bg_color.vue?vue&type=style&index=0&id=e88bb144&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88bb144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e88bb144')) {
      api.createRecord('e88bb144', component.options)
    } else {
      api.reload('e88bb144', component.options)
    }
    module.hot.accept("./c_bg_color.vue?vue&type=template&id=e88bb144&scoped=true", function () {
      api.rerender('e88bb144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_bg_color.vue"
export default component.exports